//* ======= RESPONSE ERRORS ========
export const  MSG_ERRORS_NO_AUTH_SESSION = ["Token Id is not valid", "IP Public is not valid", "Session User not found", "ipPublic must be an ip address"]
export const MSG_ERRORS_INVALID_TOKEN = ["Token is invalid", "Token signature is invalid", "Token is malformed", "Token is expired"];

export const SOCIAL_MEDIA = {
  FACEBOOK: {
      name: "Facebook",
      classIcon: "fa-brands fa-facebook",
      classColor: "text-facebook",
      classBackground: "bg-facebook",
      variant: "facebook",
      //color: "#4267B2"
  },
  INSTAGRAM: {
      name: "Instagram",
      classIcon: "fa-brands fa-instagram",
      classColor: "text-instagram",
      classBackground: "bg-instagram",
      variant: "instagram",
      //color: "#E1306C"
  },
  X: {
      name: "X",
      classIcon: "fa-brands fa-x-twitter",
      classColor: "text-x",
      classBackground: "bg-x",
      variant: "x",
      oldVariant: "twitter",
      //color: "#000000"
  },
  TWITTER: {
      name: "X",
      classIcon: "fa-brands fa-x-twitter",
      classColor: "text-x",
      classBackground: "bg-x",
      variant: "x",
      color: "#000000"
  },
  LINKEDIN: {
      name: "LinkedIn",
      classIcon: "fa-brands fa-linkedin",
      classColor: "text-linkedin",
      classBackground: "bg-linkedin",
      variant: "linkedin",
      //color: "#000000"
  },
  YOUTUBE: {
      name: "YouTube",
      classIcon: "fa-brands fa-youtube",
      classColor: "text-youtube",
      classBackground: "bg-youtube",
      variant: "youtube",
      //color: "#FF0000"
  }
}